import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import moment from 'moment';
import { dateTimeFormat } from '../../../util/GlobalConstant';
import { Alert } from 'reactstrap';

import RangedDtPicker from '../../../components/RangedDtPicker';
import {
  StatusFilter,
  SubStatusFilters
} from '../../../components/StatusFilter';
import ColumnFilter from '../../../components/ColumnFilter';

import style from './index.scss';

import {
  columnData,
  getAlertsAnomalyTable,
  getFilterParams
} from './metaUtils';

import { getInvestigationData } from '../../../redux/actions/tm/investigation';

import {
  DEFAULT_OFFSET,
  tmDefaultPageSize,
  tmUserManagementResourcesArray
} from '../../../util/GlobalConstant';
import Pager from 'react-pager';
import { ConfigData } from '../../../util/ABUtil';
import { getItemFromLocalStorage } from '../../../util/localStorageUtils';
import { isUiResourceAvailable } from '../../../util/index';

/**
 * Investigation
 */
class Investigation extends React.Component {
  // eslint-disable-line react/prefer-stateless-function
  /**
   * constructor
   * @param props
   */
  constructor(props) {
    super(props);

    let dateRange = {
      startDate: moment(new Date()).subtract(30, 'days').add(1, 'days'),
      endDate: moment(new Date()),
      activeRangeNo: 2
    };

    try {
      const LCDateValue = localStorage.getItem('tm-listing-date');

      if (LCDateValue) {
        const storedDateRange = JSON.parse(LCDateValue);
        dateRange = {
          startDate: moment(storedDateRange?.startDate, dateTimeFormat),
          endDate: moment(storedDateRange?.endDate, dateTimeFormat),
          activeRangeNo: storedDateRange?.activeRangeNo
        };
      }
    } catch (err) {
      console.log('dateRange err: ', err);
    }

    const tableFilterPref = localStorage.getItem('investTableFilter') || '{}';

    this.state = {
      dateRange,
      activeStatusNo: -1,
      activeSubStatusNo: ConfigData.IS_NCD_NOT_AVAILABLE ? 0 : -1,
      userFilterSetting: JSON.parse(tableFilterPref),
      currentPage: DEFAULT_OFFSET,
      searchText: null
    };

    this.searchTextBoxRef = React.createRef(null);
  }

  /**
   * componentDidMount
   */
  componentDidMount() {
    this.dispatchInitialRequest();
  }

  /**
   * onDateChange
   * @param start
   * @param end
   * @param rangeNo
   */
  onDateChange = (start, end, rangeNo) => {
    this.searchTextBoxRef.current.value = '';

    const newDateRange = {
      startDate: start,
      endDate: end,
      activeRangeNo: rangeNo
    };

    const storedDateRange = {
      startDate: moment(start).format(dateTimeFormat),
      endDate: moment(end).format(dateTimeFormat),
      activeRangeNo: rangeNo
    };

    localStorage.setItem('tm-listing-date', JSON.stringify(storedDateRange));

    this.setState(
      {
        ...this.state,
        dateRange: newDateRange,
        searchText: null,
        currentPage: DEFAULT_OFFSET
      },
      () => {
        const { dispatch } = this.props;
        const {
          dateRange: { startDate, endDate },
          activeSubStatusNo,
          activeStatusNo
        } = this.state;
        const params = getFilterParams(
          activeSubStatusNo,
          activeStatusNo,
          startDate,
          endDate,
          DEFAULT_OFFSET
        );
        dispatch(getInvestigationData(params));
      }
    );
  };

  /**
   * onPageChanged
   * @param newPage
   */
  onPageChanged = (newPage) => {
    this.setState(
      {
        ...this.state,
        currentPage: newPage
      },
      () => {
        const { dispatch } = this.props;
        const {
          dateRange: { startDate, endDate },
          activeSubStatusNo,
          activeStatusNo
        } = this.state;
        const params = getFilterParams(
          activeSubStatusNo,
          activeStatusNo,
          startDate,
          endDate,
          newPage
        );
        dispatch(getInvestigationData(params));
      }
    );
  };

  /**
   * onSearchClick
   */
  onSearchClick = () => {
    const { dispatch } = this.props;
    const {
      dateRange: { startDate, endDate },
      activeSubStatusNo,
      activeStatusNo,
      searchText
    } = this.state;

    this.setState(
      {
        activeSubStatusNo: -1,
        activeStatusNo: -1
      },
      () => {
        let params = getFilterParams(
          -1,
          -1,
          startDate,
          endDate,
          DEFAULT_OFFSET,
          searchText
        );
        dispatch(getInvestigationData(params));
      }
    );
  };

  /**
   * onSearchTextChange
   * @param e
   */
  onSearchTextChange = (e) => {
    const searchText = e.target.value;
    this.setState({
      ...this.state,
      searchText: searchText.trim() !== '' ? searchText : null,
      currentPage: DEFAULT_OFFSET
    });
  };

  /**
   * onStatusFilterChange
   * @param index
   */
  onStatusFilterChange = (index) => {
    this.searchTextBoxRef.current.value = '';
    const { dispatch } = this.props;
    this.setState(
      {
        ...this.state,
        activeStatusNo: index,
        activeSubStatusNo: -1,
        searchText: null,
        currentPage: DEFAULT_OFFSET
      },
      () => {
        if (dispatch) {
          const {
            dateRange: { startDate, endDate },
            activeSubStatusNo,
            activeStatusNo
          } = this.state;
          const params = getFilterParams(
            activeSubStatusNo,
            activeStatusNo,
            startDate,
            endDate,
            DEFAULT_OFFSET
          );
          dispatch(getInvestigationData(params));
        }
      }
    );
  };

  /**
   * onSubStatusFilterChange
   * @param index
   */
  onSubStatusFilterChange = (index) => {
    this.searchTextBoxRef.current.value = '';
    const { dispatch } = this.props;
    this.setState(
      {
        ...this.state,
        activeSubStatusNo: index,
        searchText: null,
        currentPage: DEFAULT_OFFSET
      },
      () => {
        if (dispatch) {
          const {
            dateRange: { startDate, endDate },
            activeSubStatusNo,
            activeStatusNo
          } = this.state;
          const params = getFilterParams(
            activeSubStatusNo,
            activeStatusNo,
            startDate,
            endDate,
            DEFAULT_OFFSET
          );
          dispatch(getInvestigationData(params));
        }
      }
    );
  };

  /**
   * onTableFilterChange
   * @param filterPref
   */
  onTableFilterChange = (filterPref) => {
    this.setState({
      ...this.state,
      userFilterSetting: filterPref,
      currentPage: DEFAULT_OFFSET
    });
    localStorage.setItem('investTableFilter', JSON.stringify(filterPref));
  };

  /**
   * dispatchInitialRequest
   */
  dispatchInitialRequest = () => {
    const { dispatch } = this.props;

    const {
      dateRange: { startDate, endDate },
      activeSubStatusNo,
      activeStatusNo
    } = this.state;
    const params = getFilterParams(
      activeSubStatusNo,
      activeStatusNo,
      startDate,
      endDate,
      DEFAULT_OFFSET
    );
    if (dispatch) {
      dispatch(getInvestigationData(params));
    }
  };

  renderColumnFilters = (activeStatusNo, userFilterSetting) => {
    return (
      <ColumnFilter
        filterGroupData={columnData}
        statusNo={activeStatusNo}
        userFilterSetting={userFilterSetting}
        handleConfirm={this.onTableFilterChange}
      />
    );
  };

  render() {
    const {
      dateRange,
      activeStatusNo,
      activeSubStatusNo: activeSubStatusNumber,
      userFilterSetting,
      currentPage
    } = this.state;

    const {
      investigation: { isLoading, listingResp, error },
      authentication
    } = this.props;
    const isUsingUserManagement =
      getItemFromLocalStorage('user-management-enabled') === 'true';
    let isAllowedDetailsPage = isUsingUserManagement ? false : true;

    // confirm if using user management, if user has access to details page
    if (isUsingUserManagement) {
      if (
        authentication &&
        Array.isArray(authentication.data) &&
        authentication.data.length > 0
      ) {
        const listOfUiResources = authentication.data?.map((attributeItem) => {
          return attributeItem?.details?.resource?.resourceCode;
        });

        // true if user has access to a single resource in details page
        tmUserManagementResourcesArray.tmAlertDetails.forEach((uiResource) => {
          if (isUiResourceAvailable(uiResource, listOfUiResources)) {
            isAllowedDetailsPage = true;
          }
        });
      }
    }

    // get and confirm the selected alert type from what we queried
    // remember:
    // alert is 0, anomaly is 1 for the API
    // it is not the case for the UI though
    // 0 = all, 1 = alert, 2 = anomaly
    const selectedAlertType =
      activeSubStatusNumber === -1
        ? 'all'
        : activeSubStatusNumber === 0
        ? 'alert'
        : 'anomlay';

    const investigationData = listingResp || {};
    const statusFilterData = investigationData?.statusWiseCount || {
      all: 0,
      open: 0,
      closed: 0
    };

    // count for different types of alerts
    const subStatusFilterData = investigationData.typeWiseCount || {
      all: 0,
      alert: 0,
      anomlay: 0
    };

    // list of alerts
    let alerts = investigationData.list || [];

    let mainTable = (
      <Alert
        color="info"
        style={{
          width: '100%',
          margin: 0,
          minHeight: '50vh'
        }}>
        <p>
          <i className="fa fa-info-circle" />
          &nbsp;&nbsp;
          {isLoading ? 'Loading...' : 'No alerts available'}.
        </p>
      </Alert>
    );

    if (alerts.length > 0 && !isLoading) {
      mainTable = getAlertsAnomalyTable(
        mainTable,
        alerts,
        userFilterSetting,
        this.dispatchInitialRequest,
        isAllowedDetailsPage
      );
    } else if (error && !isLoading) {
      mainTable = (
        <Alert
          color="danger"
          style={{ width: '100%', margin: 0, minHeight: '50vh' }}>
          <p>
            <i className="fa fa-info-circle" />
            &nbsp;&nbsp;
            {error.message}
          </p>
        </Alert>
      );
    }

    return (
      <div className={style.wrapper}>
        <div className={classnames('row', style.topFilter)}>
          <div className={classnames('col-md-6')}>
            <StatusFilter
              filterData={statusFilterData}
              activeIndex={activeStatusNo}
              handleClick={this.onStatusFilterChange}
            />
          </div>
          <div className={classnames('col-md-5 text-right')}>
            <RangedDtPicker
              useRedux={true}
              startDate={dateRange.startDate}
              endDate={dateRange.endDate}
              activeRangeNo={dateRange.activeRangeNo}
              onDateChange={this.onDateChange}
            />
          </div>
          <div className={classnames('col-md-1')}>
            {this.renderColumnFilters(activeStatusNo, userFilterSetting)}
          </div>
        </div>
        <div
          className="row"
          style={{
            width: '100%',
            margin: 0,
            backgroundColor: 'white',
            overflow: 'scroll',
            maxHeight: '600px'
          }}>
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'space-between'
            }}>
            <div style={{ padding: 10 }} className={style.substatusFilter}>
              <SubStatusFilters
                filterData={subStatusFilterData}
                activeIndex={activeSubStatusNumber}
                handleClick={this.onSubStatusFilterChange}
              />
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                height: 44,
                marginRight: 120
              }}
              className={classnames('col-md-2')}>
              <div className="input-group search-panel">
                <input
                  id="searchText"
                  ref={this.searchTextBoxRef}
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  onChange={this.onSearchTextChange}
                />
                <span
                  className="input-group-addon"
                  id="searchTextClickBtn"
                  style={{
                    cursor: 'pointer',
                    display: 'grid',
                    placeItems: 'center'
                  }}
                  onClick={this.onSearchClick}>
                  <i className="fa fa-search" aria-hidden="true"></i>
                </span>
              </div>
            </div>
          </div>
          {mainTable}
          <div style={{ width: '100%', justifyContent: 'flex-end' }}>
            <Pager
              className={classnames('pull-right', style.pager)}
              total={
                Math.ceil(
                  subStatusFilterData[selectedAlertType] / tmDefaultPageSize
                ) || 0
              }
              current={currentPage}
              visiblePages={5}
              onPageChanged={this.onPageChanged}
            />
          </div>
        </div>
      </div>
    );
  }
}

Investigation.propTypes = {
  dispatch: PropTypes.func
};

/**
 * mapStateToProps
 * @param state
 * @param ownProps
 * @returns {{app: *, investigation: investigation, authentication: (authentication|{isAuthed: boolean})}}
 */
function mapStateToProps(state, ownProps = {}) {
  return {
    app: state.app,
    investigation: state.tmInvestigation,
    authentication: state.authentication
  };
}

/**
 * mapDispatchToProps
 * @param dispatch
 * @param ownProps
 * @returns {{dispatch: *}}
 */
function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Investigation);

export const InvestigationWithoutStore = Investigation;
